import {UTILITIES_FETCHED, UTILITY_CREATED, UTILITY_UPDATED, UTILITY_DELETED} from "./actionType";
import {Action} from "redux-actions";
import {OnFailure, OnSuccessData} from "../actionHelpers";
import {api} from "../../../api/api";
import {Dispatch} from "react-redux";
import Utility from "../../../model/utility/Utility";

function utilitiesFetched(utilities: Array<Utility>): Action<UTILITIES_FETCHED> {
	return {type: UTILITIES_FETCHED, payload: {utilities}};
}

function utilityCreated(utility: Utility): Action<UTILITY_CREATED> {
	return {type: UTILITY_CREATED, payload: {utility}};
}

function utilityUpdated(utility: Utility): Action<UTILITY_UPDATED> {
	return {type: UTILITY_UPDATED, payload: {utility}};
}

function utilityDeleted(utilityId: string): Action<UTILITY_DELETED> {
	return {type: UTILITY_DELETED, payload: {utilityId}};
}

export function fetchUtilities(onSuccess: OnSuccessData<Utility[]> = () => {}, onFailure: OnFailure = () => {}) {
	return function(dispatch: Dispatch<any>) {
		api.instance.utilityApi.fetchUtilities().then(utilities => {
			dispatch(utilitiesFetched(utilities));
			onSuccess(utilities);
		}).catch(onFailure);
	};
}

export function createUtility(
	utility: Utility,
	onSuccess: OnSuccessData<Utility>,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.utilityApi.createUtility(utility).then(utility => {
			dispatch(utilityCreated(utility));
			onSuccess(utility);
		}).catch(onFailure);
	};
}

export function updateUtility(
	utilityId: string,
	utility: Utility,
	onSuccess: OnSuccessData<Utility>,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.utilityApi.updateUtility(utilityId, utility).then(utility => {
			dispatch(utilityUpdated(utility));
			onSuccess(utility);
		}).catch(onFailure);
	};
}

export function deleteUtility(
	utilityId: string,
	onSuccess: OnSuccessData<void>,
	onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.utilityApi.deleteUtility(utilityId).then(() => {
			dispatch(utilityDeleted(utilityId));
			onSuccess();
		}).catch(onFailure);
	};
}